var map = {
	"./banners/session-annual2025": 2,
	"./banners/session-annual2025.png": 2,
	"./banners/session-annual3000": 3,
	"./banners/session-annual3000.png": 3,
	"./banners/session-tech2025": 4,
	"./banners/session-tech2025.png": 4,
	"./circle": 5,
	"./circle.png": 5,
	"./default-avatar": 6,
	"./default-avatar.jpg": 6,
	"./logos/WindEurope": 7,
	"./logos/WindEurope.svg": 7,
	"./logos/wind-energy-hamburg": 8,
	"./logos/wind-energy-hamburg.svg": 8,
	"./logos/windeurope-annual-2022": 9,
	"./logos/windeurope-annual-2022.svg": 9,
	"./logos/windeurope-annual2024": 10,
	"./logos/windeurope-annual2024.svg": 10,
	"./logos/windeurope-annual2025": 11,
	"./logos/windeurope-annual2025.svg": 11,
	"./logos/windeurope-annual3000": 12,
	"./logos/windeurope-annual3000.svg": 12,
	"./logos/windeurope-confex2019": 13,
	"./logos/windeurope-confex2019.svg": 13,
	"./logos/windeurope-ec2021": 14,
	"./logos/windeurope-ec2021.svg": 14,
	"./logos/windeurope-eolis2022": 15,
	"./logos/windeurope-eolis2022.svg": 15,
	"./logos/windeurope-eolis2023": 16,
	"./logos/windeurope-eolis2023.svg": 16,
	"./logos/windeurope-offshore2019": 17,
	"./logos/windeurope-offshore2019.svg": 17,
	"./logos/windeurope-summit2018": 18,
	"./logos/windeurope-summit2018.svg": 18,
	"./logos/windeurope-tech2022": 19,
	"./logos/windeurope-tech2022.svg": 19,
	"./logos/windeurope-tech2023": 20,
	"./logos/windeurope-tech2023.svg": 20,
	"./logos/windeurope-tech2025": 21,
	"./logos/windeurope-tech2025.svg": 21,
	"./session": 22,
	"./session.png": 22,
	"./team/andreas": 23,
	"./team/andreas.jpg": 23,
	"./team/bert": 24,
	"./team/bert.jpg": 24,
	"./team/dominique": 25,
	"./team/dominique.jpg": 25,
	"./team/jason": 26,
	"./team/jason.jpg": 26,
	"./team/lorenzo": 27,
	"./team/lorenzo.jpg": 27,
	"./team/mariaisabel": 28,
	"./team/mariaisabel.jpg": 28,
	"./team/petr": 29,
	"./team/petr.jpg": 29,
	"./team/rebecca": 30,
	"./team/rebecca.jpg": 30,
	"./team/stergiani": 31,
	"./team/stergiani.jpg": 31,
	"./team/william": 32,
	"./team/william.jpg": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;